// extracted by css-extract-rspack-plugin
export default {"text":"w6MHDW1kywfZlUJp","small":"zG9hobgv0WYzk4qD","medium":"exO3B5N6e74e1yWc","large":"CbvM5HZDd28ehxt0","bold":"EKBOBpCqgUCDDCjZ","truncate":"gSYFjXodtcoSufoC"};